import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelectPokemon } from '../../../../../../Hooks/Admin';

export const useFormularioPokedex = () => {
    const { data: pokemones } = useSelectPokemon({ conNumero: true });

    const columnas = [
        {
            title: "Pokemon",
            dataIndex: "poke_nombre",
            width: "25%",
        },
        {
            title: "N° Pokedex",
            dataIndex: "numero_pokedex",
            width: "15%",
        },
        {
            title: "N° Dex",
            dataIndex: "poke_numero_pokedex",
            width: "15%",
        },
        {
            title: "Consistente",
            dataIndex: "inconsistente",
            width: "10%",
            render: (_, record) => {
                if (record.numero_pokedex !== record.poke_numero_pokedex) {
                    return <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: '18px' }} />;
                }
                return <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '18px' }} />;
            }
        },
    ];

    const camposFormulario = {
        title: "Filtros",
        campos: [
            {
                name: "poke_nombre",
                label: "Nombre Pokemon",
                type: "text"
            },
            {
                name: "numero_pokedex",
                label: "Numero Pokedex",
                type: "number"
            },
        ]
    };

    const camposFormularioCrear = (idUsuario) => {
        const pokemonOptions = (pokemones || []).map(p => ({
            value: p.value,
            label: p.label,
            poke_numero_pokedex: p.poke_numero_pokedex,
        }));

        return {
            title: "Agregar a Pokedex",
            campos: [
                {
                    name: "usua_id",
                    label: "Id del usuario",
                    type: "number",
                    defaultValue: idUsuario,
                    disabled: true,
                    hidden: true,
                    rules: [
                        {
                            required: true,
                            message: "Campo requerido",
                        }
                    ],
                },
                {
                    name: "poke_id",
                    label: "Pokemon",
                    type: "autocomplete",
                    opciones: pokemonOptions,
                    rules: [
                        {
                            required: true,
                            message: "Campo requerido",
                        }
                    ],
                },
                {
                    name: "numero_pokedex",
                    label: "Numero Pokedex (opcional)",
                    type: "number",
                    placeholder: "Si no se pasa, toma el N° Dex del pokemon"
                }
            ]
        }
    };

    return {
        columnas,
        camposFormulario,
        camposFormularioCrear,
    };
};
